/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PlanTier,
    PlanTierFromJSON,
    PlanTierFromJSONTyped,
    PlanTierToJSON,
} from './';

/**
 * 
 * @export
 * @interface CheckoutRequest
 */
export interface CheckoutRequest {
    /**
     * 
     * @type {PlanTier}
     * @memberof CheckoutRequest
     */
    planTier: PlanTier;
}

export function CheckoutRequestFromJSON(json: any): CheckoutRequest {
    return CheckoutRequestFromJSONTyped(json, false);
}

export function CheckoutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckoutRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'planTier': PlanTierFromJSON(json['planTier']),
    };
}

export function CheckoutRequestToJSON(value?: CheckoutRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'planTier': PlanTierToJSON(value.planTier),
    };
}

